// @flow
import { createRoot } from "react-dom/client";

import App from "./App";
import "./output.css";
import * as Sentry from "@sentry/react";
// import { BrowserRouter } from "react-router-dom";

// createRoot(document.getElementById("root")).render(
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>,
// );

Sentry.init({
  dsn: "https://947613e76af788bad600c83c297b02fb@o4509166360592384.ingest.us.sentry.io/4510820765401088",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
